import React from "react";
import MultiLanguageEditor from "../MultiLanguageEditor";

const demoText = {
  it: "prova",
  en: "test",
  fr: "",
  es: "",
};

const LottoInformations = () => {
  return (
    <div className="px-3">
      <div className="text-600 font-medium text-600 text-xl mb-3">
        <span style={{ color: "black" }}>Informazioni Lotto</span>
      </div>
      <MultiLanguageEditor textValue={demoText} />
    </div>
  );
};

export default LottoInformations;
